import React, { useState } from "react";
import { apiService } from "../apiService";
import { useT } from "../i18n/useT";

// Countries requiring explicit opt-in consent for marketing emails (GDPR, etc.)
const OPT_IN_REQUIRED = new Set([
  'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT',
  'LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE',
  'GB','NO','IS','LI','CH',
  'JP','KR','BR','CN','AR','CA',
]);

/**
 * Post-signup welcome modal. Shows for new users in opt-in-required countries
 * who haven't yet set their email marketing preference.
 *
 * Visibility condition (checked by parent):
 *   userData != null && !userData.anonymous && userData.email_marketing_opt_in == null
 *   && OPT_IN_REQUIRED.has(userData.country_code)
 */
const WelcomeModal = ({ userData }) => {
  const t = useT();
  const [optIn, setOptIn] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    setSaving(true);
    try {
      await apiService.updateEmailOptIn(optIn);
    } catch (err) {
      console.error("Failed to save email opt-in:", err);
      // Still dismiss — Firestore onSnapshot may not fire, but we don't want
      // to trap the user. The field stays null and they'll be re-prompted next session.
    }
    setSaving(false);
  };

  const firstName = userData?.firstName || userData?.displayName?.split(" ")[0] || "";

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/55">
      <div className="bg-white rounded-xl shadow-xl w-[280px] mx-4 p-5">
        <p className="text-sm font-semibold text-gray-900 mb-1">
          {t('welcome_title')}!
        </p>
        <p className="text-xs text-gray-400 mb-4">
          {t('welcome_subtitle')}
        </p>
        <label className="flex items-center gap-2 cursor-pointer mb-4">
          <input
            type="checkbox"
            checked={optIn}
            onChange={(e) => setOptIn(e.target.checked)}
            className="w-3.5 h-3.5 rounded border-gray-300 text-[#635BFF] focus:ring-[#635BFF] cursor-pointer flex-shrink-0"
          />
          <span className="text-xs text-gray-500">
            {t('auth_email_optin')} <span className="text-[#635BFF] font-medium">{t('welcome_optin_reward')}</span>
          </span>
        </label>
        <button
          onClick={handleSubmit}
          disabled={saving}
          className="w-full py-2 bg-[#635BFF] text-white rounded-lg text-xs font-semibold hover:bg-[#4B44CC] transition-colors disabled:opacity-50"
        >
          {t('welcome_continue')}
        </button>
      </div>
    </div>
  );
};

export { OPT_IN_REQUIRED };
export default WelcomeModal;
